import { inquiryReferralCode } from "../actions/referral";

export const checkAndSetReferralCode = async () => {
    const params = new URLSearchParams(window.location.search);
    const referral = params.get("r")

    if (referral) {
        const checkReferral = await inquiryReferralCode(referral);
        if (checkReferral.code === 200 && checkReferral.status === "SUCCESS") {
            localStorage.setItem('referral_code', JSON.stringify({
                "code": referral,
                "storedAt": Date.now(),
                "expireIn": 30 * 24 * 60 * 60 * 1000 // 30 days expired
            }));
        }
    } else {
        const raw = localStorage.getItem('referral_code');
        if (!raw) return;

        const { storedAt, expireIn } = JSON.parse(raw);

        const now = Date.now();
        const isExpired = now - storedAt > expireIn;

        if (isExpired) {
            localStorage.removeItem('referral_code');
            return;
        }
    }

    return
};